import { render, staticRenderFns } from "./hardwareProducts.vue?vue&type=template&id=0bbcfaa6&scoped=true"
import script from "./hardwareProducts.vue?vue&type=script&lang=js"
export * from "./hardwareProducts.vue?vue&type=script&lang=js"
import style0 from "./hardwareProducts.vue?vue&type=style&index=0&id=0bbcfaa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbcfaa6",
  null
  
)

export default component.exports